var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelsAtlasOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#19242F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4511 14.1731C16.1312 13.9886 15.7234 14.0982 15.538 14.4173L10.6282 22.9204C10.4437 23.2403 10.5533 23.6488 10.8724 23.8334C10.978 23.8946 11.0924 23.9236 11.2061 23.9236C11.4374 23.9236 11.6614 23.8035 11.7856 23.5892L16.6953 15.0861C16.8799 14.7662 16.7711 14.3569 16.4511 14.1731Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2728 17.328C17.9528 17.1427 17.5442 17.2531 17.3596 17.5722L14.2713 22.9205C14.0867 23.2404 14.1963 23.6489 14.5155 23.8335C14.6211 23.8947 14.7355 23.9237 14.8491 23.9237C15.0805 23.9237 15.3045 23.8036 15.4286 23.5893L18.517 18.241C18.7023 17.9219 18.5927 17.5126 18.2728 17.328Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0939 20.482C19.774 20.2974 19.3654 20.407 19.1808 20.7261L17.9139 22.9204C17.7293 23.2403 17.8389 23.6489 18.1581 23.8334C18.2636 23.8946 18.3781 23.9236 18.4917 23.9236C18.723 23.9236 18.9471 23.8036 19.0712 23.5892L20.3381 21.395C20.5235 21.0751 20.4139 20.6665 20.0939 20.482Z",
    fill: "#00AEEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4398 10.6075C17.0909 10.0023 15.7764 7.67993 15.7764 7.67993C15.7764 7.67993 14.4425 10.0023 14.0944 10.6067L13.8236 11.0749L12.6558 13.0991H12.6582C12.4881 13.4158 12.5978 13.8123 12.9113 13.9928C13.0168 14.054 13.1321 14.083 13.2449 14.083C13.4762 14.083 13.7003 13.9629 13.8244 13.7486L15.3613 11.0757L15.7691 10.3657L23.5682 23.9237H25.1099L17.4398 10.6075Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4904 16.0574H12.4888C12.662 15.7399 12.554 15.3418 12.2389 15.1597C11.919 14.9752 11.5104 15.0848 11.3258 15.4039L6.3999 23.923H7.94327L12.4904 16.0574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsAtlasOne);
export default __webpack_public_path__ + "static/media/ChannelsAtlasOne.9a43a333edb61e0759d8cf392fed0cfc.svg";
export { ForwardRef as ReactComponent };